import styled from 'particles/themes/styled'
import { theme } from 'theme'
interface SubListButtonProps {
    isActive: boolean
}
interface TaskSummaryHeaderContainerProps {
    isActive?: boolean
    isDraggable?: boolean
    isDragDisabled?: boolean
    showClose?: boolean
}
export const TaskSidebarContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 244px;
    max-height: 100%;
    height: 100%;
    background-color: ${theme.newColors.neutral50};
    padding: ${theme.newSpacing.s};
    box-sizing: border-box;
    .title {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        margin-bottom: ${theme.newSpacing.s};
    }
    .ordering-error {
        margin-bottom: ${theme.newSpacing.s};
    }
    .task-button {
        position: relative;
        margin: ${theme.newSpacing.m} 0;
        align-items: flex-start;
    }
    .steps-buttons-group {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.m};
        padding-left: 20px;
        box-sizing: border-box;
        margin-bottom: ${theme.newSpacing.m};
        font-size: ${theme.newFontSizes.s};
    }
    .non-draggable-group {
        padding-left: 0;
    }
    .popup-content {
        text-align: center;
    }
    .task-card {
        padding: ${theme.newSpacing.xxxxs};
        background-color: ${theme.newColors.neutral50};
    }
    .task-header {
        height: fit-content;
        display: grid;
        align-items: center;
        gap: ${theme.newSpacing.xxs};
        grid-template-columns: auto 1fr;
        .title-area {
            cursor: grab;
        }
    }
    .isDragging {
        box-shadow: ${theme.boxShadow.level3};
    }
`
export const TaskListContainer = styled.div`
    width: 264px;
    max-height: 360px;
    overflow-y: scroll;
    background-color: ${theme.newColors.neutral50};
    padding: ${theme.newSpacing.xxs};
    box-sizing: border-box;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    .task-button {
        box-sizing: border-box;
        width: 100%;
    }
    ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 7px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }
    .task-title {
        color: ${theme.newColors.neutral400};
        margin-bottom: ${theme.newSpacing.m};
        font-size: ${theme.newFontSizes.xs};
    }
    .divider {
        margin: ${theme.newSpacing.xxs} 0;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .popup-content {
        text-align: center;
    }
    z-index: 200;
`
export const SubListButton = styled.div<SubListButtonProps>`
    color: ${({ isActive }) => (isActive ? theme.newColors.primary300 : theme.newColors.neutral500)};
    font-weight: ${({ isActive }) => (isActive ? theme.fontWeight.bold : theme.fontWeight.medium)};
    cursor: pointer;
`
export const StepListButton = styled.div<SubListButtonProps>`
    display: block;
    text-decoration: none;
    color: ${({ isActive }) => (isActive ? theme.newColors.primary300 : theme.newColors.neutral500)};
    font-weight: ${theme.fontWeight.medium};
    background-color: ${({ isActive }) => (isActive ? theme.newColors.neutral100 : theme.newColors.neutral50)};
    cursor: pointer;
    font-size: ${theme.newFontSizes.s};
    height: 33px;
    line-height: 33px;
    padding: 0 ${theme.newSpacing.l};
    box-sizing: border-box;
    text-align: left;
`
export const SubListDropListContainer = styled.div<SubListButtonProps>`
    max-height: ${({ isActive }) => (isActive ? '1000px' : 0)};
    overflow: hidden;
    transition: all 0.2s linear;
    .drop-list {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.xxs};
        border-left: 1px solid ${theme.newColors.neutral200};
        margin-top: ${theme.newSpacing.m};
    }
`
export const TaskSummaryHeaderContainer = styled.div<TaskSummaryHeaderContainerProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${theme.newColors.neutral400};
    svg {
        height: ${theme.newFontSizes.m};
    }
    .drag-icon {
        cursor: ${({ isDragDisabled }) => (isDragDisabled ? 'no-drop' : 'grab')};
    }
    .task-title {
        cursor: ${({ isDraggable, isDragDisabled }) => (isDragDisabled ? 'pointer' : isDraggable ? 'grab' : 'pointer')};
    }
    .comment-close-area {
        display: flex;
        flex-direction: column;
        justify-content: ${({ showClose }) => (showClose ? 'space-between' : 'flex-end')};
        align-items: end;
        // This positioning is necessary to get the div to be 100% of the height of its dynamic parent
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        height: 100%;
    }
    .comment-count {
        width: 32px;
        height: 18px;
        gap: ${({ theme }) => theme.spacing[200]};
        border: 1px solid ${({ theme }) => theme.colors.border.primary};
        border-radius: 20px;
        text-align: center;
        box-sizing: border-box;
    }

    .title-area {
        width: calc(100% - 28px);
        display: flex;
        align-items: flex-start;
        min-height: 28px;
        .fill-can-change {
            margin-right: ${theme.newSpacing.xxxs};
            path {
                fill: ${({ isActive }): string => (isActive ? theme.newColors.neutral700 : theme.newColors.neutral400)};
            }
        }
        .stroke-can-change {
            margin-right: ${theme.newSpacing.xxxs};
            path {
                stroke: ${({ isActive }): string =>
                    isActive ? theme.newColors.neutral700 : theme.newColors.neutral400};
            }
        }
    }
`
